import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import React, { useEffect } from "react";
import { sizes } from "../approvalUtils";
import { views } from "./cgpgUtils";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerGroups, getProductGroups, setState } from "./cgpgSlice";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function Form() {
  const dispatch = useDispatch();
  const states = useSelector((store) => store.cgpgApproval);
  const {
    searchText,
    selectedView,
    groupStatusList,
    selectedGroupStatus,
    periods,
    selectedPeriod,
    countries,
    selectedCountry,
    selectedCountryID,
    navigatedCountryID,
  } = states;

  const loginState = useSelector((store) => store.login);
  const { globalSelectedCountryName, globalSelectedCountryID } = loginState;

  useEffect(() => {
    // debugger;
    if (
      globalSelectedCountryName !== null &&
      globalSelectedCountryName !== ""
    ) {
      dispatch(setState("selectedCountry", globalSelectedCountryName));
      dispatch(setState("selectedCountryID", globalSelectedCountryID));
      dispatch(setState("CGPGAGlobalCountrtID", globalSelectedCountryID));
    } else {
      dispatch(setState("selectedCountry", ""));
      dispatch(setState("selectedCountryID", ""));
      dispatch(setState("CGPGAGlobalCountrtID", ""));
    }
  }, [globalSelectedCountryID]);

  useEffect(() => {
    let name = "";
    if (navigatedCountryID !== "") {
      if (countries.length > 0) {
        name = countries.find(
          (country) => country.countryID === navigatedCountryID
        ).countryName;

        dispatch(setState("selectedCountry", name));
        dispatch(setState("selectedCountryID", navigatedCountryID));
      }
    }
  }, [countries]);

  function setView(event) {
    dispatch(setState("selectedRows", []));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("productGroupsTable", null));
    dispatch(setState("customerGroupsTable", null));
    dispatch(setState("clickedRowComment", ""));
    dispatch(setState("groupRowClicked", false));
    dispatch(setState("selectedGroupStatus", "All"));
    if (
      globalSelectedCountryID === null ||
      globalSelectedCountryID === "" ||
      globalSelectedCountryID === undefined
    ) {
      dispatch(setState("selectedCountry", "All"));
      dispatch(setState("selectedCountryID", 0));
    }

    dispatch(setState("selectedPeriod", "All"));
    dispatch(setState("searchText", ""));
    const view = event.target.value;
    dispatch(setState("selectedView", view));
  }

  function setSearchText(event) {
    const text = event.target.value;
    dispatch(setState("searchText", text));
  }

  function setGroupStatus(event) {
    dispatch(setState("selectedRows", []));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("productGroupsTable", null));
    dispatch(setState("customerGroupsTable", null));
    dispatch(setState("clickedRowComment", ""));
    dispatch(setState("groupRowClicked", false));
    const status = event.target.value;
    dispatch(setState("selectedGroupStatus", status));
  }

  function setCountry(event) {
    dispatch(setState("navigatedCountryID", ""));
    dispatch(setState("selectedRows", []));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("productGroupsTable", null));
    dispatch(setState("customerGroupsTable", null));
    dispatch(setState("clickedRowComment", ""));
    dispatch(setState("groupRowClicked", false));
    const name = event.target.value;
    let id = 0;
    if (name !== "All") {
      id = countries.find((country) => country.countryName === name).countryID;
    }
    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", id));
  }

  function setPeriod(event) {
    dispatch(setState("selectedRows", []));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("productGroupsTable", null));
    dispatch(setState("customerGroupsTable", null));
    dispatch(setState("clickedRowComment", ""));
    dispatch(setState("groupRowClicked", false));
    const period = event.target.value;
    dispatch(setState("selectedPeriod", period));
  }
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  function search() {
    if (selectedView === null || selectedView === "") {
      showMessage("Please select an option from View menu", "info");
      return;
    } else if (selectedGroupStatus == null || selectedGroupStatus === "") {
      showMessage("Please select group status", "info");
      return;
    } else if (selectedCountryID === null || selectedCountryID === "") {
      showMessage("Please select country", "info");
      return;
    } else if (selectedPeriod === null || selectedPeriod === "") {
      showMessage("Please select period", "info");
      return;
    }
    dispatch(setState("productGroupsTable", null));
    dispatch(setState("customerGroupsTable", null));
    dispatch(setState("customerGroups", null));
    dispatch(setState("productGroups", null));
    dispatch(setState("selectedRows", []));
    dispatch(setState("clickedRowComment", ""));
    dispatch(setState("groupRowClicked", false));

    const obj = {
      logedUser: JSON.parse(localStorage.getItem("data")),
      countryId: selectedCountryID,
      groupStatus: selectedGroupStatus,
      period: selectedPeriod,
      searchText: searchText,
    };

    if (selectedView === "Product Group") {
      dispatch(getProductGroups(obj));
    } else {
      dispatch(getCustomerGroups(obj));
    }
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Grid container columns={12} columnGap={2} rowGap={2}>
        <Grid item sm={2}>
          <FormControl>
            <InputLabel>View By</InputLabel>
            <Select
              value={selectedView}
              label="ViewBy"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setView}
            >
              {views.map((view, index) => {
                return (
                  <MenuItem key={index} value={view.value}>
                    {view.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sm={2}>
          <FormControl>
            <InputLabel>Group Status</InputLabel>
            <Select
              value={selectedGroupStatus}
              label="Group Status"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setGroupStatus}
            >
              {groupStatusList.map((status, index) => {
                return (
                  <MenuItem key={index} value={status.value}>
                    {status.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sm={2}>
          <FormControl>
            <InputLabel>Country</InputLabel>
            <Select
              value={selectedCountry}
              label="Country"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setCountry}
            >
              <MenuItem value={"All"}>{"All"}</MenuItem>
              {countries.map((country, index) => {
                return (
                  <MenuItem key={index} value={country.countryName}>
                    {country.countryName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sm={2}>
          <FormControl>
            <InputLabel>Period</InputLabel>
            <Select
              value={selectedPeriod}
              label="Period"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setPeriod}
            >
              {periods.map((period, index) => {
                return (
                  <MenuItem key={index} value={period.value}>
                    {period.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sm={2}>
          <TextField
            placeholder="Type your search"
            inputProps={{
              sx: {
                p: 2,
                width: selectWidth,
                height: selectHeight,
              },
            }}
            value={searchText}
            onChange={setSearchText}
          />
        </Grid>

        <Grid item sm={0.8}>
          <Button
            startIcon={<ManageSearchIcon />}
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": {
                bgcolor: "darkred.main",
                color: "white.main",
              },
            }}
            onClick={search}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
